import { Box } from "prosapient-styleguide"
import styled from "styled-components"

const CONTAINER_MAX_WIDTH = 1440

export const Container = styled(Box)`
  margin: 0 auto;
  max-width: ${CONTAINER_MAX_WIDTH}px;
`
